document.addEventListener('DOMContentLoaded', () => {
    const mappe = document.querySelectorAll('[data-mappa]');
    if (typeof maplibregl !== 'undefined' && mappe.length > 0) {
        mappe.forEach((mappa) => {
            const mappaData = JSON.parse(mappa.dataset.mappa);
            const sedi = mappaData.sedi || [];
            const zoom = mappaData.zoom;
            const stile = mappaData.stile;
            const image = mappaData.image;

            // Filtra solo le sedi con coordinate valide
            const sediConCoordinate = sedi.filter(sede => sede.coordinate && sede.coordinate.latitudine && sede.coordinate.longitudine);

            // Calcola il centro medio dei marker
            let centerLat = 0, centerLng = 0, count = 0;
            sediConCoordinate.forEach(sede => {
                centerLat += parseFloat(sede.coordinate.latitudine);
                centerLng += parseFloat(sede.coordinate.longitudine);
                count++;
            });
            if (count > 0) {
                centerLat /= count;
                centerLng /= count;
            } else {
                centerLat = 0;
                centerLng = 0;
            }

            const map = new maplibregl.Map({
                container: mappa,
                style: 'https://tiles.openfreemap.org/styles/liberty',
                center: [centerLng, centerLat],
                zoom: zoom,
                cooperativeGestures: true,
            });


            // Crea un marker per ogni sede con coordinate valide e aggiungi popup
            sediConCoordinate.forEach(sede => {
                const markerEl = document.createElement('div');
                markerEl.className = 'marker';
                markerEl.style.backgroundImage = `url('${image}')`;
                markerEl.style.width = '32px';
                markerEl.style.height = '38.4px';

                const popup = new maplibregl.Popup({ offset: 25 })
                    .setHTML(`
                        <h3 class="font-bold text-00 uppercase">${sede.nome_sede || ''}</h3>
                        <span class="text-00 inline-block mt-1">${sede.indirizzo || ''}</span>
                    `);

                new maplibregl.Marker({ element: markerEl })
                    .setLngLat([
                        parseFloat(sede.coordinate.longitudine),
                        parseFloat(sede.coordinate.latitudine)
                    ])
                    .setPopup(popup)
                    .addTo(map);
            });

            map.addControl(new maplibregl.NavigationControl());
        });
    }
});
